import { SYMBOLS_FOOD } from "./ui/symbols";

export const slots = [
  {
    id: "slot-1",
    data: SYMBOLS_FOOD,
    animation: "rotateCounterClockwise 0.3s infinite linear",
  },
  {
    id: "slot-2",
    data: SYMBOLS_FOOD,
    animation: "rotateClockwise 0.5s infinite linear",
  },
  {
    id: "slot-3",
    data: SYMBOLS_FOOD,
    animation: "rotateClockwise 1s infinite linear",
  },
  {
    id: "slot-4",
    data: SYMBOLS_FOOD,
    animation: "rotateCounterClockwise 1s infinite linear",
  },
];
